import React from 'react';
import {
  Box,
  Container,
  Typography,
  Link,
  Grid,
} from '@mui/material';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#041D5C',
        color: '#ffffff',
        py: { xs: 6, md: 8 },
        px: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={{ xs: 3, sm: 4, md: 6 }} sx={{ mb: { xs: 3, sm: 4, md: 6 } }}>
          <Grid item xs={12} sm={6} md={3}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1.25, sm: 1.5 }, mb: { xs: 1.5, sm: 2 } }}>
              <Box
                sx={{
                  width: { xs: 32, md: 40 },
                  height: { xs: 32, md: 40 },
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'linear-gradient(135deg, #9333EA 0%, #EC4899 100%)',
                  borderRadius: '8px',
                  flexShrink: 0,
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: '18px', md: '24px' },
                    fontWeight: 700,
                    color: '#ffffff',
                  }}
                >
                  D
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 400,
                  fontSize: { xs: '14px', sm: '15px', md: '16px' },
                  lineHeight: { xs: '20px', sm: '22px', md: '24px' },
                  letterSpacing: '-0.31px',
                  color: '#FFFFFF',
                }}
              >
                DataVerse
              </Typography>
            </Box>
            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 400,
                fontSize: { xs: '12px', sm: '13px', md: '14px' },
                lineHeight: { xs: '18px', sm: '19px', md: '20px' },
                letterSpacing: '-0.15px',
                color: '#FFFFFFCC',
                mb: 1,
              }}
            >
              Enterprise-grade data engineering platform
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 600,
                fontSize: { xs: '13px', sm: '14px', md: '15px' },
                lineHeight: { xs: '19px', sm: '20px', md: '22px' },
                letterSpacing: '-0.15px',
                color: '#FFFFFF',
              }}
            >
              Powered by Hyperminds Tech
            </Typography>
            </motion.div>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontSize: { xs: '14px', sm: '15px', md: '16px' },
                lineHeight: { xs: '20px', sm: '22px', md: '24px' },
                letterSpacing: '-0.31px',
                color: '#FFFFFF',
                mb: { xs: 1.5, sm: 2, md: 3 },
              }}
            >
              Products
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 1.25, sm: 1.5, md: 2 } }}>
              <Link
                href="#"
                sx={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 400,
                  fontSize: { xs: '12px', sm: '13px', md: '14px' },
                  lineHeight: { xs: '18px', sm: '19px', md: '20px' },
                  letterSpacing: '-0.15px',
                  color: '#FFFFFFCC',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease',
                  '&:hover': {
                    color: '#FFFFFF',
                    textDecoration: 'none',
                  },
                }}
              >
                ETL & Orchestration
              </Link>
              <Link
                href="#"
                sx={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 400,
                  fontSize: '14px',
                  lineHeight: '20px',
                  letterSpacing: '-0.15px',
                  color: '#FFFFFFCC',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease',
                  '&:hover': {
                    color: '#FFFFFF',
                    textDecoration: 'none',
                  },
                }}
              >
                Logs Transformation
              </Link>
              <Link
                href="#"
                sx={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 400,
                  fontSize: '14px',
                  lineHeight: '20px',
                  letterSpacing: '-0.15px',
                  color: '#FFFFFFCC',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease',
                  '&:hover': {
                    color: '#FFFFFF',
                    textDecoration: 'none',
                  },
                }}
              >
                Data Migration
              </Link>
            </Box>
            </motion.div>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: '24px',
                letterSpacing: '-0.31px',
                color: '#FFFFFF',
                mb: { xs: 2, md: 3 },
              }}
            >
              Company
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 1.25, sm: 1.5, md: 2 } }}>
              <Link
                href="#"
                sx={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 400,
                  fontSize: { xs: '12px', sm: '13px', md: '14px' },
                  lineHeight: { xs: '18px', sm: '19px', md: '20px' },
                  letterSpacing: '-0.15px',
                  color: '#FFFFFFCC',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease',
                  '&:hover': {
                    color: '#FFFFFF',
                    textDecoration: 'none',
                  },
                }}
              >
                About
              </Link>
              <Link
                href="#"
                sx={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 400,
                  fontSize: '14px',
                  lineHeight: '20px',
                  letterSpacing: '-0.15px',
                  color: '#FFFFFFCC',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease',
                  '&:hover': {
                    color: '#FFFFFF',
                    textDecoration: 'none',
                  },
                }}
              >
                Careers
              </Link>
              <Link
                href="#"
                sx={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 400,
                  fontSize: '14px',
                  lineHeight: '20px',
                  letterSpacing: '-0.15px',
                  color: '#FFFFFFCC',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease',
                  '&:hover': {
                    color: '#FFFFFF',
                    textDecoration: 'none',
                  },
                }}
              >
                Contact
              </Link>
            </Box>
            </motion.div>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: '24px',
                letterSpacing: '-0.31px',
                color: '#FFFFFF',
                mb: { xs: 2, md: 3 },
              }}
            >
              Resources
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 1.25, sm: 1.5, md: 2 } }}>
              <Link
                href="#"
                sx={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 400,
                  fontSize: { xs: '12px', sm: '13px', md: '14px' },
                  lineHeight: { xs: '18px', sm: '19px', md: '20px' },
                  letterSpacing: '-0.15px',
                  color: '#FFFFFFCC',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease',
                  '&:hover': {
                    color: '#FFFFFF',
                    textDecoration: 'none',
                  },
                }}
              >
                Documentation
              </Link>
              <Link
                href="#"
                sx={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 400,
                  fontSize: '14px',
                  lineHeight: '20px',
                  letterSpacing: '-0.15px',
                  color: '#FFFFFFCC',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease',
                  '&:hover': {
                    color: '#FFFFFF',
                    textDecoration: 'none',
                  },
                }}
              >
                Blog
              </Link>
              <Link
                href="#"
                sx={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 400,
                  fontSize: '14px',
                  lineHeight: '20px',
                  letterSpacing: '-0.15px',
                  color: '#FFFFFFCC',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease',
                  '&:hover': {
                    color: '#FFFFFF',
                    textDecoration: 'none',
                  },
                }}
              >
                Support
              </Link>
            </Box>
            </motion.div>
          </Grid>
        </Grid>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
        <Box
          sx={{
            borderTop: '1px solid rgba(255, 255, 255, 0.2)',
            pt: { xs: 3, sm: 3.5, md: 4 },
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 2.5, sm: 0 },
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 400,
              fontSize: { xs: '12px', sm: '13px', md: '14px' },
              lineHeight: { xs: '18px', sm: '19px', md: '20px' },
              letterSpacing: '-0.15px',
              color: '#FFFFFFCC',
              order: { xs: 2, sm: 1 },
              textAlign: { xs: 'center', sm: 'left' },
            }}
          >
            © 2025 Hyperminds Tech. All rights reserved.
          </Typography>
          <Box
            sx={{
              display: 'flex',
              gap: { xs: 2.5, sm: 3, md: 4 },
              order: { xs: 1, sm: 2 },
            }}
          >
            <Link
              href="#"
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 400,
                fontSize: { xs: '12px', sm: '13px', md: '14px' },
                lineHeight: { xs: '18px', sm: '19px', md: '20px' },
                letterSpacing: '-0.15px',
                color: '#FFFFFFCC',
                textDecoration: 'none',
                transition: 'color 0.2s ease',
                '&:hover': {
                  color: '#FFFFFF',
                  textDecoration: 'none',
                },
              }}
            >
              Privacy
            </Link>
            <Link
              href="#"
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 400,
                fontSize: { xs: '12px', sm: '13px', md: '14px' },
                lineHeight: { xs: '18px', sm: '19px', md: '20px' },
                letterSpacing: '-0.15px',
                color: '#FFFFFFCC',
                textDecoration: 'none',
                transition: 'color 0.2s ease',
                '&:hover': {
                  color: '#FFFFFF',
                  textDecoration: 'none',
                },
              }}
            >
              Terms
            </Link>
          </Box>
        </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Footer;
